import Image from 'next/image'

import CSS from './section-divider.module.css'

export const SectionDivider = ({ heading, theme }) => {
    return (
        <section className={`${CSS.layout} bg-primary`} >
            <div className={CSS.graphic}>
                <img className={CSS.mobile} src={`/assets/theme/2027/2027-theme-strip.png`} />
            </div>

            <p className={`
                ${CSS.heading} fs-2 fw-600 lh-2 c-white`}>{ heading }</p>
        </section>
    )
}